<template>
  <div>
    <b-modal ref="accoutingPeriod" id="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <basic-table
        :items="accountingPeriod"
        :fields="accountingPeriodFields"
        @RowSelected="accountingPeriodSelected"/>
        <b-row>
          <b-col>
            <b-button variant="success" style="float: right ;width: 100px" @click.stop="selectAccoutingPeriod">Ok</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button  variant="secondary" style="float: right ;width: 100px" @click.stop="$refs.accoutingPeriod.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  data () {
    return {
      selectedAccountingPeriod: null,
      accountingPeriodFields: [
        {key: 'static_id', label: 'ID', sortable: true},
        {key: 'id', label: this.$i18n.t('Serial ID'), sortable: true},
        {key: 'begin2', label: this.$i18n.t('Start date'), sortable: true},
        {key: 'end2', label: this.$i18n.t('End date'), sortable: true},
        {key: 'namePeriodicType', label: this.$i18n.t('Period type'), sortable: true}
      ]
    }
  },
  methods: {
    accountingPeriodSelected (row) {
      this.selectedAccountingPeriod = row
    },
    selectAccoutingPeriod () {
      if (!this.selectedAccountingPeriod) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
        return
      }
      this.$emit('input', this.selectedAccountingPeriod.id)
      this.$emit('displayAccountingPeriod')
      this.$refs.accoutingPeriod.hide()
    }
  },
  computed: {
    accountingPeriod () {
      let copy = JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))
      copy = copy.filter(function (value) {
        return value.static_id !== 0
      })
      for (let el of copy) {
        el.begin2 = moment(Number(el.begin) * 1000).format('YYYY-MM-DD hh:mm')
        el.end2 = moment(Number(el.end) * 1000).format('YYYY-MM-DD hh:mm')
        el.namePeriodicType = ''
        switch (el.periodic_type) {
          case 1:
            el.namePeriodicType = this.$i18n.t('Daily')
            break
          case 2:
            el.namePeriodicType = this.$i18n.t('Weekly')
            break
          case 3:
            el.namePeriodicType = this.$i18n.t('Monthly')
            break
          case 4:
            el.namePeriodicType = this.$i18n.t('Quarterly')
            break
          case 5:
            el.namePeriodicType = this.$i18n.t('Annual')
            break
          case 1048576:
            el.namePeriodicType = this.$i18n.t('Custom duration')
            break
        }
      }
      return copy
    }
  },
  mounted () {
    this.$store.dispatch('Tariffing/GET_ACCOUNTING_PERIODS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formAccountingPeriod.vue